import { createStore, combineReducers, applyMiddleware, compose, Middleware, Reducer } from 'redux';
import reduxThunk from 'redux-thunk';
import reduxLogger from 'redux-logger';
import { IStoreState, IAction } from './types';
import voiceStore from '@/views/Voice/store';
import userReducer from './module/user';
import appReducer from './module/app';
import settingsReducer from './module/setting';
import noticeReducer from './module/notice';
import transationReducer from './module/transation';
import liveReducer from './module/live';
import giftBannerReducer from './liveData/giftBanner';
import communityReducer from './module/community';
import liveHeadReducer from './module/liveHead';
import navConfigReducer from './module/navConfig';
import recentPlayGameReducer from './module/recentPlayGame';
import breadcrumbReducer from './module/breadcrumb';
import homePageReducer from './homeModule/homePage';
import homeJXListReducer from './homeModule/homeJXlist';
import homeNewGameReducer from './homeModule/homeNewGame';
import homeCommunityReducer from './homeModule/homeCommunity';
import homeSuitReducer from './homeModule/homeSuit';
import homeRankingReducer from './homeModule/homeRanking';
import baseDataReducer from './baseData';
import baseTipReducer from './baseData/baseTip';
import baseTipLiveReducer from './baseData/baseTipLive';
import realnameReducer from './baseData/realnameStatus';
import competitionReducer from './module/competition';
import homeMemberReducer from './homeModule/homeMember';
import trumpetInfoReducer from './baseData/trumpetInfo';
import iframeDanmuInfoReducer from './iframeDanmu';
import gameDetailReducer from './gameDetail/gameDetail';
import homeNewSuitReducer from './homeModule/homeNewSuit';
import notActivatedReducer from './userMember/notActivated';
import svipUserInfoReducer from './userMember/svipUserInfo';
import svipRightsReducer from './userMember/svipRights';
import mitgateReducer from './userMember/mitgate';
import routeJumpReducer from './module/routeJump';
import customerReducer from './userMember/customer';
import customInfoReducer from './liveData/customInfo';
import anchorInfoReducer from './liveData/anchorInfo';
import tradingsReducer from './tradingReconsituition';
import shopCartConfReducer from './module/shopCartConf';

const reducers: Reducer<IStoreState, IAction<any>> = combineReducers<IStoreState>({
  user: userReducer,
  app: appReducer,
  settings: settingsReducer,
  notices: noticeReducer,
  transation: transationReducer,
  live: liveReducer,
  giftBannerInfo: giftBannerReducer,
  communitys: communityReducer,
  liveHead: liveHeadReducer,
  navInfo: navConfigReducer,
  playGameInfo: recentPlayGameReducer,
  breadcrumbInfo: breadcrumbReducer,
  homePage: homePageReducer,
  homeJXList: homeJXListReducer,
  homeNewGame: homeNewGameReducer,
  homeCommunity: homeCommunityReducer,
  homeSuit: homeSuitReducer,
  homeRanking: homeRankingReducer,
  baseInfo: baseDataReducer,
  baseTipInfo: baseTipReducer,
  baseTipLiveInfo: baseTipLiveReducer,
  realnameInfo: realnameReducer,
  competition: competitionReducer,
  homeMember: homeMemberReducer,
  trumpetInfo: trumpetInfoReducer,
  iframeDanmuInfo: iframeDanmuInfoReducer,
  gameDetails: gameDetailReducer,
  homeNewSuit: homeNewSuitReducer,
  notActivateds: notActivatedReducer,
  svipUserInfos: svipUserInfoReducer,
  svipRights: svipRightsReducer,
  mitgate: mitgateReducer,
  routeJump: routeJumpReducer,
  customer: customerReducer,
  customInfo: customInfoReducer,
  anchorTipInfo: anchorInfoReducer,
  trading: tradingsReducer,
  shopCartConf: shopCartConfReducer,
  ...voiceStore
});

const middleware: Middleware[] = [reduxThunk];

if (process.env.NODE_ENV === 'development' && false) {
  middleware.push(reduxLogger);
}

function createMyStore() {
  /* eslint-disable no-underscore-dangle */
  const store = window.__REDUX_DEVTOOLS_EXTENSION__
    ? createStore(reducers, compose(applyMiddleware(...middleware), window.__REDUX_DEVTOOLS_EXTENSION__({})))
    : createStore(reducers, applyMiddleware(...middleware));

  return store;
}

const store = createMyStore();

export default store;
